import { Autocomplete, Box, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Paper, TextField, Typography } from "@mui/material";
import { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { useTranslation } from "react-i18next";
import CancelButton from "../../../components/button/CancelButton";
import ConfirmButton from "../../../components/button/ConfirmButton";
import RefreshButton from "../../../components/button/RefreshButton";
import { InvitationCollaborateProduct } from "../../../db_access/invitation_collaborate_product";
import { InvitationCollaborateProject } from "../../../db_access/invitation_collaborate_project";
import { Partnership } from "../../../db_access/partnership";
const DialogSend = forwardRef(({ selectedItems }, ref) => {
  const { t } = useTranslation();
  const [partners, setPartners] = useState([]);
  const [receiver, setReceiever] = useState(null);
  const [open, setOpen] = useState(false);
  const [refresh, setRefresh] = useState(true);
  useImperativeHandle(ref, () => ({
    open: () => setOpen(true),
    close: () => setOpen(false),
  }));
  const sendInvitationProduct = (receiver_id) =>
    InvitationCollaborateProduct.send(
      selectedItems.filter((s) => s._type === "Product").map((s) => s.id),
      receiver_id
    );

  const sendInvitationProject = (receiver_id) =>
    InvitationCollaborateProject.send(
      selectedItems.filter((s) => s._type === "Project").map((s) => s.id),
      receiver_id
    );

  const send = () => {
    if (receiver.value) {
      const productFetch = sendInvitationProduct(receiver.value);
      const projectFetch = sendInvitationProject(receiver.value);
      Promise.all([productFetch, projectFetch])
        .catch((error) => {
          console.error("Error fetching data:", error);
        })
        .finally(() => setOpen(false));
    }
  };
  useEffect(() => {
    Partnership.get_my_partners()
      .then((res) => {
        if (res.ok) {
          return res.json();
        } else {
          return null;
        }
      })
      .then((data) => {
        if (data) {
          setPartners(data.map((d) => ({ label: d.name, value: d.id })));
        }
      });
  }, [refresh]);
  useEffect(() => console.log(receiver), [receiver]);
  return (
    <Dialog
      open={open}
      onClose={() => setOpen(false)}
      fullWidth
      sx={{}}
      PaperProps={{
        sx: {
          width: "auto",
          maxWidth: "none",
          padding: 2,
          overflow: "visible",
        },
      }}>
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}>
        <Box>
          <Typography
            sx={{
              fontFamily: "Poppins",
              fontSize: "24px",
              color: "black",
              textWrap: "nowrap",
            }}>
            {t("Send Products to Partner")}
          </Typography>
        </Box>
        <Box>
          <RefreshButton setRefresh={setRefresh} />
        </Box>
      </DialogTitle>
      <DialogContent
        sx={{
          overflow: "visible",
        }}>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 8,
            paddingY: 2,
          }}>
          <Box>
            <Typography
              sx={{
                fontFamily: "Poppins",
                fontSize: "20px",
                textWrap: "nowrap",
              }}>
              {t("Products to be sent:")}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            {selectedItems.map((s, i) => (
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "20px",
                  textWrap: "nowrap",
                  textAlign: "right",
                }}
                key={i}>
                {s.product}
              </Typography>
            ))}
          </Box>
        </Box>
        <FormControl fullWidth sx={{ overflow: "visible" }}>
          <Typography sx={{ fontFamily: "Poppins", fontSize: "16px", color: "black", textWrap: "nowrap", textAlign: "left", padding: 0.5 }}>{t("Partner")}</Typography>
          <Autocomplete
            disablePortal
            options={partners}
            value={receiver}
            onChange={(event, newValue) => setReceiever(newValue)}
            ListboxProps={{
              sx: {
                fontFamily: "Poppins",
                "& .MuiAutocomplete-option": {
                  fontFamily: "Poppins",
                  "&:hover": {
                    backgroundColor: "rgba(23, 163, 74, 0.2)",
                  },
                },
              },
            }}
            componentsProps={{
              popper: {
                modifiers: [
                  { name: "flip", enabled: false },
                  { name: "preventOverflow", enabled: false },
                ],
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Partner"
                sx={{
                  "& .MuiInputBase-root": {
                    fontFamily: "Poppins",
                  },
                  "& .MuiOutlinedInput-root": {
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: 3,
                      borderColor: "#16a34a",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                      borderColor: "#16a34a",
                    },
                  },
                }}
              />
            )}
            PaperComponent={(props) => <Paper {...props} sx={{ fontFamily: "Poppins" }} />}
          />
        </FormControl>
      </DialogContent>
      <DialogActions sx={{ paddingX: 4 }}>
        <CancelButton onClick={() => setOpen(false)} label={"Cancel"} />
        <ConfirmButton onClick={send} label={"Send"} />
      </DialogActions>
    </Dialog>
  );
});
export default DialogSend;
